<template>
  <div
    v-if="!item.product.isSerenityPack"
    class="flex items-center justify-between border-b pb-6 pr-10"
  >
    <div v-if="cartDisplay && item.product.slug">
      <a :href="`/${item.product.slug}`">
        <VImg
          :src="item.product.media"
          :hover="item.product.hoverMedia"
          alt="Produit"
          class="w-32 object-contain"
        />
      </a>
    </div>
    <div v-else>
      <VImg
        :src="item.product.media"
        alt="Produit"
        class="w-32 object-contain"
      />
    </div>

    <div class="flex-1 sm:pl-6 pl-2 space-y-3">
      <div class="flex items-center gap-x-2 justify-between">
        <p class="font-medium text-sm">
          {{ item.product.isVirtual ? item.orderItem.product_name : item.product.name }}
        </p>
        <button
          class="text-gray-500 self-start text-2xl"
          @click="deleteItem(item)"
        >
          <VIconSpinnerSecondary
            v-if="currentActionLoading === 'delete'"
            class="animate-spin size-6 spinner"
          />
          <v-icon-trash
            v-else
            class="!size-6 hover:scale-105 transition-transform duration-200"
          />
        </button>
      </div>

      <div
        v-if="!item.product.isVirtual"
        class="flex flex-row items-center justify-between sm:pr-6 pr-4 space-x-3"
      >
        <div class="flex items-center space-x-3">
          <span class="font-semibold">{{ displayPrice }}</span>

          <div
            v-if="hasDiscount"
            class="flex items-center space-x-3"
          >
            <span
              class="line-through text-gray-500 text-sm"
            >
              {{ originalPrice }}
            </span>
            <span
              class="bg-black text-white px-1 text-sm font-semibold"
            >
              -{{ item.product.price.discountFactor }}%
            </span>
          </div>
          <div v-if="item.product.reconditionned">
            <p class="text-sm font-semibold text-white bg-milikaki px-1">
              {{ trans.get('miliboo.product.reconditionned') }}
            </p>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-between gap-3">
        <div class="flex items-center justify-between border w-fit px-2 py-1 gap-2">
          <button
            class="w-4"
            :class="{
              'cursor-not-allowed opacity-50': item.product.isVirtual || item.quantity <= 1,
            }"
            @click="decreaseQuantity(item)"
          >
            <VIconSpinnerSecondary
              v-if="currentActionLoading === 'decrease'"
              class="animate-spin size-3 spinner"
            />
            <v-icon-minus v-else />
          </button>
          <span class="w-8 text-center font-medium">{{ item.quantity }}</span>
          <button
            class="w-4"
            :class="{
              'cursor-not-allowed opacity-50': item.product.isVirtual || item.quantity >= item.availableQuantity,
            }"
            @click="increaseQuantity(item)"
          >
            <VIconSpinnerSecondary
              v-if="currentActionLoading === 'increase'"
              class="animate-spin size-3 spinner"
            />
            <v-icon-plus v-else />
          </button>
        </div>
        <div
          v-if="cartDisplay"
          class="flex items-center justify-end space-x-3"
        >
          <span class="font-semibold">{{ amountItemsPrice }}&nbsp;€</span>
        </div>
      </div>
      <div
        v-if="isStockLimited && !item.product.isVirtual"
        class="text-sm font-semibold text-blue-500 mt-4"
      >
        {{ trans.get('miliboo.cart.quantity-update-to-match-stock') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  defineEmits,
  watch,
} from 'vue';
import VIconSpinnerSecondary from '../../../icons/VIconSpinnerSecondary.vue';
import useCartSummaryItem from '../composable/useCartSummaryItem';
import VImg from '../../../components/common/VImg.vue';

const emit = defineEmits(['item-out-of-stock']);

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  isPro: {
    type: Boolean,
    default: false,
  },
  cartDisplay: {
    type: Boolean,
    default: false,
  },
  isFetching: {
    type: Boolean,
    default: false,
  },
});

const {
  deleteItem,
  trans,
  currentActionLoading,
  isStockLimited,
  displayPrice,
  originalPrice,
  amountItemsPrice,
  hasDiscount,
  increaseQuantity,
  decreaseQuantity,
} = useCartSummaryItem(props, emit);

watch(() => props.isFetching, () => {
  if (!props.isFetching) {
    currentActionLoading.value = null;
  }
});

</script>
